import {
  handleWithErrorMessage,
  handleWithGlobalMessage
} from "@/services/utils";
import organisationUnitApi from "@/services/modules/organisations/organisation-units";
import {
  SET_IS_FETCHING_ORGANISATION_UNITS,
  SET_ORGANISATION_UNITS,
  SET_SCOPED_USERS,
  SET_IS_FETCHING_SCOPED_USERS,
  SET_SCOPED_USERS_PREVIEW,
  SET_IS_FETCHING_SCOPED_USERS_PREVIEW,
  SET_CLIENT_ORGANISATION_UNITS,
  SET_ARCHIVED_UNITS,
  SET_PARENT_UNITS,
  SET_IS_FETCHING_PARENT_UNITS
} from "@/store/modules/organisations/organisation-units/mutations";

export const FETCH_ORGANISATION_UNITS = "FETCH_ORGANISATION_UNITS";
export const ARCHIVE_ORGANISATION_UNIT = "ARCHIVE_ORGANISATION_UNIT";
export const PUBLISH_ORGANISATION_UNIT = "PUBLISH_ORGANISATION_UNIT";
export const CREATE_ORGANISATION_UNIT = "CREATE_ORGANISATION_UNIT";
export const EDIT_ORGANISATION_UNIT = "EDIT_ORGANISATION_UNIT";
export const DUPLICATE_ORGANISATION_UNIT = "DUPLICATE_ORGANISATION_UNIT";
export const DELETE_ORGANISATION_UNIT = "DELETE_ORGANISATION_UNIT";
export const FETCH_SCOPED_USERS = "FETCH_SCOPED_USERS";
export const FETCH_SCOPED_USERS_PREVIEW = "FETCH_SCOPED_USERS_PREVIEW";
export const RESTORE_ORGANISATION_UNIT = "RESTORE_ORGANISATION_UNIT";
export const FETCH_CLIENT_ONLY = "FETCH_CLIENT_ONLY";
export const FETCH_ARCHIVED_UNITS = "FETCH_ARCHIVED_UNITS";
export const FETCH_PARENT_UNITS = "FETCH_PARENT_UNITS";

const actions = {
  async [FETCH_ORGANISATION_UNITS]({ commit, dispatch }, params = {}) {
    return handleWithErrorMessage({
      dispatch,
      request: () => organisationUnitApi(commit).getAll(params),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_ORGANISATION_UNITS, isLoading),
      setDataFunction: ({ data }) => commit(SET_ORGANISATION_UNITS, data)
    });
  },
  async [FETCH_PARENT_UNITS]({ commit, dispatch }, params = {}) {
    return handleWithErrorMessage({
      dispatch,
      request: () => organisationUnitApi(commit).getAll(params),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_PARENT_UNITS, isLoading),
      setDataFunction: ({ data }) => commit(SET_PARENT_UNITS, data)
    });
  },
  async [FETCH_ARCHIVED_UNITS]({ commit, dispatch }, params = {}) {
    return handleWithErrorMessage({
      dispatch,
      request: () => organisationUnitApi(commit).getAll(params),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_ORGANISATION_UNITS, isLoading),
      setDataFunction: ({ data }) => commit(SET_ARCHIVED_UNITS, data)
    });
  },
  async [FETCH_CLIENT_ONLY]({ commit, dispatch }, params = {}) {
    return handleWithErrorMessage({
      dispatch,
      request: () => organisationUnitApi(commit).getAllNoParents(params),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_ORGANISATION_UNITS, isLoading),
      setDataFunction: ({ data }) => commit(SET_CLIENT_ORGANISATION_UNITS, data)
    });
  },
  async [ARCHIVE_ORGANISATION_UNIT]({ commit, dispatch }, id) {
    await handleWithGlobalMessage(
      () => organisationUnitApi(commit).archiveOrganisationUnit(id),
      dispatch
    );
    dispatch(FETCH_ORGANISATION_UNITS);
  },
  async [CREATE_ORGANISATION_UNIT]({ commit, dispatch }, data) {
    await handleWithGlobalMessage(
      () => organisationUnitApi(commit).createOrganisationUnit(data),
      dispatch
    );
    dispatch(FETCH_ORGANISATION_UNITS);
  },
  async [EDIT_ORGANISATION_UNIT]({ commit, dispatch }, { organisation, id }) {
    await handleWithGlobalMessage(
      () =>
        organisationUnitApi(commit).editOrganisationUnit({ organisation, id }),
      dispatch
    );
    dispatch(FETCH_ORGANISATION_UNITS);
  },
  async [PUBLISH_ORGANISATION_UNIT]({ commit, dispatch }, id) {
    await handleWithGlobalMessage(
      () => organisationUnitApi(commit).publishOrganisationUnit(id),
      dispatch
    );
    dispatch(FETCH_ORGANISATION_UNITS);
  },
  async [DUPLICATE_ORGANISATION_UNIT]({ commit, dispatch }, id) {
    await handleWithGlobalMessage(
      () => organisationUnitApi(commit).duplicateOrganisationUnit(id),
      dispatch
    );
    dispatch(FETCH_ORGANISATION_UNITS);
  },
  async [DELETE_ORGANISATION_UNIT]({ commit, dispatch }, id) {
    await handleWithGlobalMessage(
      () => organisationUnitApi(commit).deleteDraftOrganisationUnit(id),
      dispatch
    );
    dispatch(FETCH_ORGANISATION_UNITS);
  },
  async [RESTORE_ORGANISATION_UNIT]({ commit, dispatch }, { id, parentId }) {
    return await handleWithGlobalMessage(
      () =>
        organisationUnitApi(commit).restoreOrganisationUnit({ id, parentId }),
      dispatch
    );
  },
  async [FETCH_SCOPED_USERS]({ commit, dispatch }, id) {
    return handleWithErrorMessage({
      dispatch,
      request: () => organisationUnitApi(commit).getScopedUsers(id),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_SCOPED_USERS, isLoading),
      setDataFunction: ({ data }) => commit(SET_SCOPED_USERS, data)
    });
  },
  async [FETCH_SCOPED_USERS_PREVIEW]({ commit, dispatch }, { id, params }) {
    return handleWithErrorMessage({
      dispatch,
      request: () =>
        organisationUnitApi(commit).getScopedUsersPreview({ id, params }),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_SCOPED_USERS_PREVIEW, isLoading),
      setDataFunction: ({ data }) => commit(SET_SCOPED_USERS_PREVIEW, data)
    });
  }
};

export default actions;
